import { render, staticRenderFns } from "./SalesProfitMarginsSupplierGroup.vue?vue&type=template&id=21bb2f6c&"
import script from "./SalesProfitMarginsSupplierGroup.vue?vue&type=script&lang=js&"
export * from "./SalesProfitMarginsSupplierGroup.vue?vue&type=script&lang=js&"
import style0 from "./SalesProfitMarginsSupplierGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports